import { TOption } from '../../../components/Select/types'
import { IPartialUserInfo } from '../../../redux/store/user/types'

export const parseUserInfoForPicker = (user: IPartialUserInfo): TOption => ({
  label: `${user.first_name} ${user.last_name}`,
  value: user.uuid
})
